import { DotLottie, DotLottieReact } from '@lottiefiles/dotlottie-react'
import { Box, Fade, useTheme } from '@mui/material'
import { useEffect, useState } from 'react'
import { useStoreActions, useStoreState } from '../../store/hooks'

const fontStyles = {
    color: '#FFF',
    fill: '#FFF',
    textAlign: 'center',
    leadingTrim: 'both',
    textEdge: 'cap',
    fontFamily: 'Space Grotesk',
    fontSize: '42',
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: '26px' /* 74.286% */,
    textTransform: 'uppercase',
    // textAnchor: 'middle',
}

export const ChallengeCompletePopup = () => {
    const theme = useTheme()
    const [dotLottie, setDotLottie] = useState<DotLottie>()
    const [showText, setShowText] = useState(false)
    const setIsCompletedChallenges = useStoreActions((state) => state.rewardsService.setIsCompletedChallenges)
    const setCompletedChallenge = useStoreActions((state) => state.rewardsService.setCompletedChallenge)
    const isCompletedChallenges = useStoreState((state) => state.rewardsService.isCompletedChallenges)
    const completedChallenge = useStoreState((state) => state.rewardsService.completedChallenge)

    useEffect(() => {
        // This function will be called when the animation is completed.
        function onComplete() {
            setIsCompletedChallenges(true)
            setCompletedChallenge(undefined)
            // onAnimationEnd()
        }

        function onFrameChange({ currentFrame }) {
            if (currentFrame > 31 && currentFrame < 130) {
                setShowText(true)
            } else {
                setShowText(false)
            }
        }

        // Listen to events emitted by the DotLottie instance when it is available.
        if (dotLottie) {
            dotLottie.addEventListener('complete', onComplete)
            dotLottie.addEventListener('frame', onFrameChange)
        }

        return () => {
            // Remove event listeners when the component is unmounted.
            if (dotLottie) {
                dotLottie.removeEventListener('complete', onComplete)
                dotLottie.removeEventListener('frame', onFrameChange)
            }
        }
    }, [dotLottie])

    const dotLottieRefCallback = (dotLottie) => {
        setDotLottie(dotLottie)
    }

    if (!completedChallenge) {
        return null
    }

    return (
        <Box
            sx={{
                position: 'fixed',
                top: -25,
                left: 0,
                right: 0,
                zIndex: 10000,
                filter: 'drop-shadow(4px 10px 4px rgba(0, 0, 0, 0.75))',
            }}
            justifyContent="center"
            height="200px"
            width="100%"
        >
            <Box position="relative" height="100%" width="100%">
                <DotLottieReact
                    dotLottieRefCallback={dotLottieRefCallback}
                    layout={{ fit: 'contain', align: [0, 0] }}
                    src="/assets/animations/rewards/mission-complete.lottie"
                    autoplay
                    renderConfig={{
                        autoResize: true,
                    }}
                />
                <Fade in={showText} timeout={700}>
                    <Box
                        sx={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            zIndex: 10000,
                            height: '200px',
                            opacity: 0,
                        }}
                    >
                        <svg
                            width="100%"
                            height="200px"
                            viewBox="0 0 857 250"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <text x="32%" y="54%" {...fontStyles} fill={theme.palette.secondary.main}>
                                {'Mission Complete!'.toUpperCase()}
                            </text>
                            <text x="32%" y="68%" {...fontStyles} fontSize="24" fill={theme.palette.secondary.main}>
                                {completedChallenge.description.toUpperCase()}
                            </text>
                        </svg>
                    </Box>
                </Fade>
            </Box>
        </Box>
    )
}
